<template>
    <div class="row">
        <div class="col-12 mb-4 d-flex">
            <h1 class="mb-0 pb-0">{{ $t('timetable-students') }}</h1>
        </div>
        <div v-if="removeSuccess" class="col-12">
            <div class="alert alert-success">{{ $t('removed-from-tt-success') }}</div>
        </div>
        <div v-if="!loading" class="col-12 mb-4">
            <div class="list-group border-radius-2 no-border">
                <div class="list-group-item text-sm font-weight-bold d-flex align-items-center">
                    {{ $t('graduated-inactive-students') }}
                    <button type="button" class="btn btn-sm btn-danger ml-auto" @click="showRemoveDialog(null)">{{ $t('delete-all') }}</button>
                </div>
                <div v-for="invalidStudent, i in invalidStudents" :key="i" class="list-group-item d-flex align-items-center">
                    <span class="mr-2">{{ invalidStudent.displayname }}</span>
                    <span class="badge mr-2" :class="`badge-${
                        invalidStudent.status == 'active' ? 'success' 
                        : invalidStudent.status == 'pending' ? 'warning'
                        : 'danger'}`"
                    >
                        {{ $t(invalidStudent.status) }}
                    </span>
                    <span v-if="invalidStudent.graduated" class="badge badge-info">
                        {{ $t('graduated') }}
                    </span>

                    <button type="button" class="btn btn-sm btn-outline-danger ml-auto" @click="showRemoveDialog([invalidStudent.user_id])">{{ $t('delete-from-tt') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {
                loading: true,
                invalidStudents: [],
                timeoutId: null,
                removeSuccess: false,
            }
        },
        mounted() {
            this.fetchInvalidEventStudents().then(() => {
                this.loading = false
            })
        },
        beforeDestroy() {
            clearTimeout(this.timeoutId)
        },
        methods: {
            fetchInvalidEventStudents() {
                return this.$cfetch(`${this.$settings.APIBaseURL}/timetables/students/listinvalid`, {
                    method: 'GET',
                    data: {
                        tttimetable_id: this.$route.params['timetableid'],
                    }
                }).then(res => {
                    if (res.status !== 'SUCCESS') {
                        throw new Error(res)
                    }

                    this.invalidStudents = Object.values(res.results)
                }).catch(err => {
                    console.error(err)
                    this.$log.error.call(this, err)
                })
            },
            showRemoveDialog(userIds=null) {
                this.$store.commit('openDialog', {
                    title: this.$t('are-you-sure'),
                    content: this.$tc(userIds ? 'delete-invalid-tt-student-question':'delete-invalid-tt-students-question'),
                    confirmCallBack: () => {
                        this.removeInvalidStudents(userIds ? userIds : this.invalidStudents.map(el => el.user_id))
                    },
                    confirmBtnText: this.$t('delete'),
                    cancelBtn: true,
                })
            },
            removeInvalidStudents(userIds=null) {
                if (this.submitting) return
                this.submitting = true

                this.removeSuccess = false
                clearTimeout(this.timeoutId)

                return this.$cfetch(`${this.$settings.APIBaseURL}/timetables/students/deleteinvalid`, {
                    method: 'POST',
                    data: {
                        tttimetable_id: this.$route.params['timetableid'],
                        user_ids: userIds,
                    },
                }).then(res => {
                    if (res.status !== 'SUCCESS') {
                        throw new Error(res)
                    }

                    userIds = userIds.reduce((prev, curr) => {
                        prev[curr] = true
                        return prev
                    }, {})

                    this.invalidStudents = this.invalidStudents.filter(el => !userIds[el.user_id])

                    this.removeSuccess = true
                    this.timeoutId = setTimeout(() => {
                        this.removeSuccess = false
                    }, 5000)
                }).catch(err => {
                    console.error(err)
                    this.$log.error.call(this, err)
                    this.$store.commit('openDialog', {
                        title: this.$t('something-went-wrong')
                    })
                }).finally(() => {
                    this.submitting = false
                })
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>